module.exports = __webpack_public_path__ + "img/startup-bg.27e78f9a.jpg";